import SearchIcon from "assets/icons/SearchIcon";
import { t } from "i18next";

import { SearchInputProps } from "./SearchInput.types";

import styles from "./SearchInput.module.scss";

const SearchInput = ({
  value,
  placeholder = "Search...",
  onChange,
  ...props
}: SearchInputProps) => {
  return (
    <div className={styles.searchBox}>
      <div className={styles.searchBox_icon}>
        <SearchIcon />
      </div>

      <input
        className={styles.searchBox_input}
        value={value}
        placeholder={t(placeholder)}
        onChange={(e) => onChange(e.target.value)}
        {...props}
      />
    </div>
  );
};

export default SearchInput;
